import commonPostTypeConfig from '../../common/postTypes/history'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'history',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
